<template>
  <div class="seek">
    <Header @getLoginInfo="getLoginInfoFn"></Header>
    <main>
      <div class="mainTop">
        <div class="underHeader">
          <img src="../../assets/img/info.png" alt />
          当前位置：
        </div>
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
        >
          <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
          <el-breadcrumb-item>我的关注</el-breadcrumb-item>
          <!-- <el-breadcrumb-item v-if="$route.query.dbcode==2" @click="intoMarket()">上市信息数据库</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item v-else @click="medical()">医药公司数据库</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="mainBottom">
        <!-- <div class="left">
          <div class="leftTit" @click="leftTab(2)" :class="{'leftTit2':$route.query.dbcode == 2}">
            <span>上市信息数据库</span>
          </div>

          <div class="leftTit" @click="leftTab(1)" :class="{'leftTit2':$route.query.dbcode == 1}">
            <span>医药公司数据库</span>
          </div>
        </div>-->
        <div class="right">
          <div class="rightTop">
            <p>我收藏的企业</p>
            <el-select v-model="order" placeholder="成立日期 从最近到过去" @change="iptChange('order')">
              <el-option
                v-for="item in orderData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                size="mini"
                style="height:32px;line-height:32px;"
              ></el-option>
            </el-select>
          </div>
          <div class="rightBottom">
            <!-- <h4
              style="margin-bottom:20px;font-size:14px;color:rgba(223, 236, 247, 1);font-weight:bold;"
            >
              当前关注的{{$route.query.dbcode == 2 ? '上市公司' : '医药公司'}}有
              <span
                style="color:#3583ED;"
              >{{totalItem}}</span>家
            </h4>-->
            <div class="tabulation">
              <el-table border size="mini" :data="tableData" :header-cell-style="cellStyle">
                <el-table-column prop="companyName" label="企业名称"></el-table-column>
                <el-table-column prop="collectTime" label="关注时间"></el-table-column>
                <el-table-column prop="companyType" label="企业类型"></el-table-column>
                <el-table-column prop="issuedPrice" label="操作">
                  <template slot-scope="scope">
                    <!-- <el-button type="text" @click="goCompanyDetail(scope.row)">查看</el-button> -->
                    <el-button type="text" @click="deleteStoreup(scope.row)">取消关注</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="width:100%;margin-top:40px;">
              <el-pagination
                prev-text="上一页"
                next-text="下一页"
                background
                @current-change="handleCurrentChange"
                :page-size="limit"
                layout="total, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>
<script>
import $ from "jquery";
window.$ = $;
import api from "@/../static/common/api/api.js";
window.api = api;
import magic from "@/../static/common/magic.js";
import Header from "@/components/header";
import Footer from "@/components/footer";
export default {
  props: {},
  components: {
    Header,
    Footer
  },
  data() {
    return {
      loginInfo: "", //header传出来的登录信息
      tableData: [],
      companyList: [],
      paramsData: {}, //URL参数集合
      offset: 0, //page
      limit: 10,
      total: 0,
      order: 0,
      orderData: [
        {
          label: "成立日期 从最近到过去",
          value: 0
        },
        {
          label: "成立日期 从过去到最近",
          value: 1
        }
      ],
      totalItem: 0
    };
  },
  computed: {},
  methods: {
    //获取header返回来的登录信息
    getLoginInfoFn(val) {
      this.loginInfo = val;
    },
    iptChange() {
      this.fetchTable();
    },
    // goCompanyDetail(val) {
    //   console.log(val, "val");

    //   if (this.$route.query.dbcode == 1) {
    //     //医药公司
    //     this.$router.push({
    //       path: "/medicine/" + this.$route.query.dbcode,
    //       query: {
    //         creditCode: val.uniqueCode
    //       }
    //     });
    //     sessionStorage.setItem("companyName", JSON.stringify(val.companyName));
    //   }
    //   if (this.$route.query.dbcode == 2) {
    //     //上市公司
    //     this.$router.push({
    //       path: "/stock/" + this.$route.query.dbcode + "/baseinfo",
    //       query: {
    //         creditCode: val.uniqueCode
    //       }
    //     });
    //   }
    // },
    // leftTab(dbcode) {
    //   let query = this.$router.history.current.query;
    //   let path = this.$router.history.current.path;
    //   let newQuery = JSON.parse(JSON.stringify(query));
    //   newQuery.dbcode = dbcode;
    //   this.$router.push({ path, query: newQuery });
    //   setTimeout(() => {
    //     this.fetchTable();
    //   }, 200);
    // },
    // 医药
    // medical() {
    //   this.$router.push({
    //     path: "/search",
    //     query: {
    //       companyName: "",
    //       dbcode: 1,
    //       pageNo: 1,
    //       pageSize: 10
    //     }
    //   });
    // },
    addStoreup() {
      //关注
      let params = {
        entId: this.entId
      };
      api.addStoreup(params).then(res => {
        if (res.message) {
          this.btnInd = 1;
        }
        this.$message({
          message: res.data,
          type: res.message
        });
      });
    },
    deleteStoreup(row) {
      //取消
      let params = {
        collectId: row.collectId
      };
      api.deleteStoreup(params).then(res => {
        if (res.data == 1) {
          this.$message({
            message: "取消关注成功",
            type: "success"
          });
          this.fetchTable();
        }
      });
    },
    isStoreup() {
      //判断是否关注
      let params = {
        entId: this.entId
      };
      api.isStoreup(params).then(res => {
        if (res.data.collectFlag) {
          this.btnInd = 1;
        }
      });
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      return "color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;";
    },
    // 分页函数
    handleCurrentChange(val) {
      //当前页
      this.offset = (val - 1) * this.limit;
      this.fetchTable();
    },
    fetchTable() {
      let _this = this;
      if (!this.$route.query.dbcode) {
        return;
      }
      let usersInfo = localStorage.getItem("usersInfo")
        ? JSON.parse(localStorage.getItem("usersInfo"))
        : "";
      let params = {
        userId: usersInfo.userId ? usersInfo.userId : "",
        order: this.order,
        dbCode: this.$route.query.dbcode == 2 ? 0 : 1,
        offset: this.offset,
        limit: this.limit
      };
      api.storeupList(params).then(res => {
        let data = res.data.rows;
        _this.totalItem = res.data.total;
        _this.total = Math.ceil(Number(res.data.total) / Number(_this.limit));
        _this.total = res.data.total;
        _this.tableData = data;
      });
    }
  },
  created() {
    //判断是否有权限，是否登录
    window.that = this;
    magic.loginOrRights(2).then(res => {
      if (!res) {
        // that.$router.push({ path: "/login" });
        this.$router.push({
          path: "/login",
          query: {
            repath: window.location.href
          }
        });
      }
      if (res && res.rights == 0) {
        that.$router.push({ path: "/index" });
      }
    });
  },
  mounted() {
    this.fetchTable(); //获取表格数据
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";

.seek {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: url("../../assets/img/bg.png") no-repeat top;
}
main {
  width: 100%;
  //min-height: e("calc(100vh - 130px)");
  //min-height: e("calc(100vh - 150px)");
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .mainTop {
    display: flex;
    .underHeader {
      display: inline-block;
      height: 54px;
      line-height: 54px;
      padding-left: 19px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
      img {
        width: 12px;
        height: 16px;
      }
    }
    /deep/ .el-breadcrumb__inner {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
  }
  .mainBottom {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px 0px 20px;
    .left {
      width: 220px;
      // height: auto;
      //height: 700px;
      margin-right: 23px;
      .leftTit {
        height: 48px;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #6d84a2;
        background: rgba(2, 50, 97, 1);
        border-radius: 2px;
        margin-bottom: 11px;
        cursor: pointer;
      }
      .leftTit2 {
        height: 48px;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fefefe;
        background: #177fe8;
        border-radius: 2px;
        margin-bottom: 11px;
        cursor: pointer;
      }
    }
  }
}
.right {
  width: 100%;
  flex: 1;
  //height: auto;
  min-height: e("calc(100vh - 175px)");
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: 50px;
    line-height: 50px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(5, 43, 79, 0.8) !important;
    border: 1px solid #08396a;
    border-radius: 2px 2px 0px 0px;

    p {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #dfecf7;
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    margin-top: 20px;
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    border: 1px solid #08396a;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
/deep/ .el-pagination__total,
/deep/.el-pagination__jump {
  color: #bac7d5;
}
</style>



// WEBPACK FOOTER //
// src/view/login/storeup.vue